import React, { useRef, useState, useEffect } from 'react';
import { Button, Form, Input } from 'semantic-ui-react';
import InlineSvg from '../../InlineSvg';
import SearchResult from '../../SearchResult';
import { useDebouncedCallback } from 'use-debounce';
import { getBaseSearchQuery } from '../../../helpers/search';

const GATSBY_SERVERLESS_API = process.env.GATSBY_SERVERLESS_API || '';

const TopNavSearch = (props) => {
  const { menuVisible } = props;

  const [responseData, setResponseData] = useState(null);
  const [, setFetching] = useState(true);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    return () => {
      // Cleanup function to abort any pending requests
      const abortController = abortControllerRef.current;
      if (abortController) {
        abortController.abort();
      }
    };
  }, []);

  const handleSearch = (e) => {
    if (!e.target.value) {
      setResponseData(null);
      return;
    }

    fetchData(e.target.value);
  };

  const fetchData = useDebouncedCallback(async (searchQuery) => {
    // Abort any pending requests
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const newAbortController = new AbortController();
    abortControllerRef.current = newAbortController;

    setFetching(true);
    try {
      const apiUrl = `${GATSBY_SERVERLESS_API}/search`;
      const requestBody = {
        ...getBaseSearchQuery(searchQuery),
        size: 5,
        _source: ['id', 'title', 'contentTypeName', 'documentTypeName', 'uri', 'fileExtension', 'fileSize', 'date', 'ancestors'],
      };

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(requestBody),
        signal: newAbortController.signal,
      });
      setFetching(false);

      if (!response.ok) {
        throw new Error('Network request failed');
      }

      const data = await response.json();
      setResponseData(data);
    } catch (error) {
      setFetching(false);
      console.error('Error fetching data:', error);
    }
  }, 300);

  return (
    <div className={`top-nav__search  ${responseData?.hits?.total?.value > 0 ? 'has-response-data' : ''}`}>
      <div className={`top-nav__search-form-wrapper`}>
        <Form action="/search" className="top-nav__search-form">
          <Button type="submit" className="top-nav__search-trigger--search" title="Search">
            <InlineSvg name="search" color="brand-primary" />
          </Button>
          <Input
            placeholder="Search..."
            title="Search"
            aria-label="Search through the website content."
            type="search"
            name="q"
            className={`top-nav__search-input ${menuVisible ? 'top-nav__search-input--menu-visible' : ''}`}
            onChange={handleSearch}
          />
          <div className="top-nav__search-suggestions-wrapper">
            <div className="top-nav__search-suggestions-container">
              {responseData?.hits?.hits.map((hit, i) => {
                return <SearchResult key={i} hit={hit} />;
              })}

              {responseData?.hits?.total?.value > 5 ? (
                <Button type="submit" className="top-nav__search-trigger--search" title="Search">
                  View all results
                </Button>
              ) : null}
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default TopNavSearch;
